import React, { useEffect, useState } from 'react'
import { Table } from 'reactstrap'
import Loading from '../components/common/Loading';
import { raiseClaimService } from '../services';

const RaisePerformanceOverview = ({ claimId }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [claimSettlementList, setClaimSettlementList] = useState(null)
    const [claimTabStatus, setClaimTabStatus] = useState({
        intimation_to_JIR: null,
        JIR_to_Last_Doc_Submitted: null,
        last_Doc_Submitted_to_FSR: null,
        FSR_to_settlement: null,
        settlement_time: null
    })

    const fetchClaimSettlementTat = async () => {
        const payload = { claimId: claimId }
        const response = await raiseClaimService.getClaimSettlementTat(payload)
        if (response?.data?.isSuccess) {
            setClaimSettlementList(response?.data?.data?.[0]?.actionDetails)
        }
    }

    const fetchClaimTabStatus = async () => {
        const claimDocRes = await raiseClaimService.getClaimDocumentDetails({
            claimId: claimId,
            fileType: "fsr"
        });
        return claimDocRes?.claimTabStatus
    }

    useEffect(() => {
        let fetchList = async () => {
            setIsLoading(true)
            let claimTabStatus = await fetchClaimTabStatus();
            await fetchClaimSettlementTat()
            setIsLoading(false)
            if (claimTabStatus) {
                const { claimDocumentDate, jirDate, lorDate, fsrDate, claimSettlementDate } = claimTabStatus;
                const calculateDaysDifference = (startDate, endDate) => {
                    if (!startDate || !endDate) return null;
                    const start = new Date(startDate);
                    const end = new Date(endDate);
                    const diffTime = Math.abs(end - start);
                    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                };

                setClaimTabStatus({
                    intimation_to_JIR: calculateDaysDifference(claimDocumentDate, jirDate),
                    JIR_to_Last_Doc_Submitted: calculateDaysDifference(jirDate, lorDate),
                    last_Doc_Submitted_to_FSR: calculateDaysDifference(lorDate, fsrDate),
                    FSR_to_settlement: calculateDaysDifference(fsrDate, claimSettlementDate),
                    settlement_time: calculateDaysDifference(claimDocumentDate, claimSettlementDate)
                });
            }
        }
        fetchList()
    }, []);

    return (
        !isLoading ?
            <div className='documents_box_wrap'>
                <div className="mb-4" style={{
                    border: '1px solid gray',
                    borderRadius: '8px',
                    padding: '16px',
                }}>
                    <h4 className='text-center'>Settlement Time (TAT): {claimTabStatus.settlement_time ? `${claimTabStatus.settlement_time} Days` : "NA"}</h4>
                    <div className='d-flex' style={{ border: "1px solid gray" }}>
                        <div className='p-4 text-center' style={{ borderRight: "1px solid black", width: "25%" }}><strong>Intimation to JIR:</strong> {claimTabStatus.intimation_to_JIR ? `${claimTabStatus.intimation_to_JIR} Days` : "NA"}</div>
                        <div className='p-4 text-center' style={{ borderRight: "1px solid black", width: "25%" }}><strong>JIR to Last Doc Submitted:</strong> {claimTabStatus.JIR_to_Last_Doc_Submitted ? `${claimTabStatus.JIR_to_Last_Doc_Submitted} Days` : "NA"}</div>
                        <div className='p-4 text-center' style={{ borderRight: "1px solid black", width: "25%" }}><strong>Last Doc Submitted to FSR:</strong> {claimTabStatus.last_Doc_Submitted_to_FSR ? `${claimTabStatus.last_Doc_Submitted_to_FSR} Days` : "NA"}</div>
                        <div className='p-4 text-center' style={{ width: "25%" }}><strong>FSR To Settlement:</strong> {claimTabStatus.FSR_to_settlement ? `${claimTabStatus.FSR_to_settlement} Days` : "NA"}</div>
                    </div>
                </div>
                <div className="table-responsive option_01">
                    <Table>
                        <thead>
                            <tr>
                                <th className='sl-n'>Sl. No.</th>
                                <th className="tbl-w-22">Action</th>
                                <th className='tbl-w-22'>Date</th>
                                <th className='tbl-w-22'>Email Id</th>
                                <th className='tbl-w-22'>Phone</th>
                                <th className='tbl-w-28'>Action By</th>
                            </tr>
                        </thead>
                        <tbody>
                            {claimSettlementList?.length && claimSettlementList.map((item, index) => (
                                <tr key={`${item?.action}_index`}>
                                    <td className='sl-n'>{index + 1}</td>
                                    <td className="tbl-w-22">{item.action || "NA"}</td>
                                    <td className='tbl-w-22'>{item.date ? item.date : "NA"}</td>
                                    <td className="tbl-w-22">{item.emailId || "NA"}</td>
                                    <td className="tbl-w-22">{item.phoneNo || "NA"}</td>
                                    <td className='tbl-w-28'>{item.actionBy || "NA"}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </div> :
            <Loading />
    )
}

export default RaisePerformanceOverview